import { ChangeDetectorRef, Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import { InputDialogComponent, InputDialogData, InputDialogReturnData } from '../components/wizards/input.dialog.component'
import { openDialogGetResult } from '../helpers/angular-helpers'
import { ManageTaskData } from '../modules/manage/manage-task-data'
import { ManageTaskComponent } from '../modules/manage/manage-task.component'
import { FilterGroupTypes } from '../store/filters.era'
import { EventMenuSelection } from '../store/reselectors/events.reselector'
import { Task, tasksActions } from '../store/tasks.era'
import { EventService } from './event.service'
import { TaskService } from './task.service'

@Injectable({ providedIn: 'root' })
export class TaskViewService {

  constructor(
    private store: Store,
    private eventService: EventService,
    private taskService: TaskService,
  ) {}

  async addTaskThroughPopupDialog({ dialog, rect, eventSelections, eventId, dateId, entityId, disableDetails }: CreateTaskData) {
    
    let position = null
    const maxHeight = window.innerHeight / 2 - 80 // max content height in dialog
    if (rect) {
      position = {}
      if (rect.right > window.innerWidth / 2) position.right = window.innerWidth - rect.right
      else position.left = rect.left
      if (rect.top < window.innerHeight / 2) position.top = rect.bottom + 2
      else position.bottom = window.innerHeight - rect.top - 2
    }
    
    const data: InputDialogData = {
      title: 'Add a task',
      placeholder: 'Task',
      backgroundColor: null,
      successLabel: 'ADD TASK',
      alternativeLabel: disableDetails ? null : 'ADD MORE DETAIL',
      small: true,
      hideCancel: true,
      alternativeEmptyOK: !disableDetails,
      position,
      maxHeight: position ? `${maxHeight}px` : 'unset'
    }
    console.log({data})
    if (eventSelections) {
      data.requireSelection = true
      data.selections = eventSelections.map(s => ({
        name: s.title,
        greyText: s.dateRange,
        id: s.id
      }))
    }
    const result = await openDialogGetResult<InputDialogReturnData>(dialog, InputDialogComponent, { width: '600px', autoFocus: true, backdropClass: 'clear', data })
    console.log({ result })
    if (!result) return
    eventId = eventSelections ? result.selection : eventId
    await this.eventService.preloadEvent(eventId)

    const task = await this.taskService.createAndSaveTask(result.values[0], eventId, dateId, entityId)
    const noTitle = !result.values[0]
    if (result.type === 'AlternativeButton') await this.manageTaskThroughDialog(dialog, task, eventId, noTitle)
  }

  async manageTaskThroughDialog(dialog: MatDialog, task: Task, eventId: string, focusTitle = true, changeDetectorRef: ChangeDetectorRef = null, filterPage: keyof FilterGroupTypes = null) {
    const event = await this.eventService.preloadEvent(eventId)
    const homePages: (keyof FilterGroupTypes)[] = ['allTasks', 'allTasksCalendar']
    const fromHome = homePages.includes(filterPage)
    const data: ManageTaskData = { task, readOnly: event.closed || event.is_suspended, fromHome } // need to add readOnly back in
    this.store.dispatch(tasksActions.taskInFocus(task.id))
    // this.changeDetectorRef.detach()
    const panelClass = 'full-screen-modal'
    // console.log({ panelClass, data, isNestedDialog })
    if (changeDetectorRef) changeDetectorRef.detach()
    await openDialogGetResult(dialog, ManageTaskComponent, { autoFocus: focusTitle, disableClose: true, data, panelClass })
    if (changeDetectorRef) changeDetectorRef.reattach()
    this.store.dispatch(tasksActions.taskInFocus(null))
  }
}

export interface CreateTaskData { dialog: MatDialog, rect?: DOMRect, eventSelections?: EventMenuSelection[], eventId?: string, dateId?: string, entityId?: string, disableDetails?: boolean }